/**
 * @memberof data-references
 * @property {object} [availableDimensions]
 * @property {object} [categoryFilters]
 * @property {number} [dimension]
 * @property {string} [dimensionName]
 * @property {number} [timeElement]
 * @property {number} [timeGroup]
 * @property {string} [unit]
 */
class DataImplementationSelection {
    constructor(props = {}) {
        Object.assign(this, props);
    }
    toJSON() {
        return Object.assign({}, this);
    }
}
export default DataImplementationSelection;
